module.exports = __webpack_public_path__ + "static/media/nf.801ee09f.svg";